/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { LocalisationDto } from '../models/localisation-dto';
import { LongLatDto } from '../models/long-lat-dto';


/**
 * Fonctions de gestion d'un recyparc (module PDA)
 */
@Injectable({
  providedIn: 'root',
})
export class ParcMobilePdaService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation parcMobilePdaLocalisation
   */
  static readonly ParcMobilePdaLocalisationPath = '/api/parc-mobile-pda/location';

  /**
   * Renvoie l'adresse du recyparc en fonction de sa latitude et sa longitude.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcMobilePdaLocalisation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcMobilePdaLocalisation$Response(params: {

    /**
     * Coordonnées à localiser
     */
    body: LongLatDto
  }): Observable<StrictHttpResponse<LocalisationDto>> {

    const rb = new RequestBuilder(this.rootUrl, ParcMobilePdaService.ParcMobilePdaLocalisationPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LocalisationDto>;
      })
    );
  }

  /**
   * Renvoie l'adresse du recyparc en fonction de sa latitude et sa longitude.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcMobilePdaLocalisation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcMobilePdaLocalisation(params: {

    /**
     * Coordonnées à localiser
     */
    body: LongLatDto
  }): Observable<LocalisationDto> {

    return this.parcMobilePdaLocalisation$Response(params).pipe(
      map((r: StrictHttpResponse<LocalisationDto>) => r.body as LocalisationDto)
    );
  }

  /**
   * Path part for operation parcMobilePdaSetVisiteLocalisation
   */
  static readonly ParcMobilePdaSetVisiteLocalisationPath = '/api/parc-mobile-pda/set-visite-location/{visiteId}';

  /**
   * Met à jour la localisation de la visite spécifiée.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `parcMobilePdaSetVisiteLocalisation()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcMobilePdaSetVisiteLocalisation$Response(params: {
    visiteId: number;
    body: LocalisationDto
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, ParcMobilePdaService.ParcMobilePdaSetVisiteLocalisationPath, 'post');
    if (params) {
      rb.path('visiteId', params.visiteId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Met à jour la localisation de la visite spécifiée.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `parcMobilePdaSetVisiteLocalisation$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  parcMobilePdaSetVisiteLocalisation(params: {
    visiteId: number;
    body: LocalisationDto
  }): Observable<number> {

    return this.parcMobilePdaSetVisiteLocalisation$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

}
